module.exports = __webpack_public_path__ + "img/plus.4b51690c.svg";